import React from 'react';
import './InputDescription.scss';
import Checkbox from 'Components/forms/checkbox/Checkbox.jsx';

function parseAttachArray(reviewAccord) {
  return reviewAccord.attachArray.map(element => {
    return (
      <div className='input-description'>
        <div className="input-description-label">
          <span>{element.title}</span>
        </div>
        <div className='desc'>
          <span>{element.desc}</span>
        </div>
      </div>
    );
  });
}

function sameLineDataArray(reviewAccord) {
  return reviewAccord.map(element => {
    return (
      <div className='input-description'>
        <div className="input-description-label">
          <span>{element.title}</span>
        </div>
        <div className='desc'>
          <span>{element.desc}</span>
        </div>
      </div>
    );
  });
}

const InputDescription = (props) => {
  const finalDescClass = props.isMerchantMessage ? 'merchant-message-description':'desc';
  return (
    <div >
      {props.getReviewPageDescription !== undefined && props.getReviewPageDescription.map((reviewAccord, index) => {
        return (
          reviewAccord.attachArray && reviewAccord.attachArray.length != 0 ?
            <div className="input-description">
              <span className="input-description-label">
                {reviewAccord.title}
              </span>
              <div className={index !== props.getReviewPageDescription.length - 1 ? 'desc-visa apply' : 'desc-visa'}>
                {reviewAccord.desc}
                <div className='input-description-attach-array'>
                  {parseAttachArray(reviewAccord)}
                </div>
              </div>
            </div>
            :
            <div className="input-description">
              {reviewAccord && Array.isArray(reviewAccord) &&
                <div className='desc apply' style={{ paddingBottom: '0px' }} >
                  <div className='input-description-attach-array' style={{ paddingTop: '0px', paddingLeft: '0px' }}>
                    {sameLineDataArray(reviewAccord)}
                  </div>

                </div>
              }
              {reviewAccord && !Array.isArray(reviewAccord) && <span className="input-description-label">
                {reviewAccord.title}
              </span>}
              {reviewAccord && !Array.isArray(reviewAccord) &&  
              <div className={  index !== props.getReviewPageDescription.length - 1 ? `${finalDescClass} apply` : finalDescClass}>{reviewAccord.desc}</div>}
              {reviewAccord.checkedBox && <Checkbox
                key={props.index}
                checkBoxKey={0}
                label={reviewAccord.checkBoxText}
                id="activeRuleCheckBox"
                isChecked={reviewAccord.status}
                disabled
                extraLabelStyle={props.extraLabelStyle}
              />}
            </div>
        );
      })}
    </div>
  );
};

export default InputDescription;
